var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1589.35 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "794.68 0 0 398.29 0 764.47 794.68 366.18 1589.35 764.47 1589.35 398.29 794.68 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "794.68 1633.82 326.88 1399.37 328.01 684.38 .39 847.95 0 1601.71 794.68 2000 1589.35 1601.71 1589.35 1235.53 794.68 1633.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1224.07 665.72 794.68 880.93 399.37 682.8 399.37 1048.98 794.68 1247.11 1589.35 848.81 1224.07 665.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutLogo);
export default __webpack_public_path__ + "static/media/nut-logo.e4d0b541bd462aa42503037e2a1ed401.svg";
export { ForwardRef as ReactComponent };